import React from 'react';
import { v4 as uuid } from 'uuid';
import { Service } from '../../../models';
import { Button } from '../../commons';
import { ClearIcon } from '../../icons';
import { Input, Textarea } from '../../inputs';

interface VolunteeringFormProps {
  services: Service[];
  setServices: React.Dispatch<React.SetStateAction<Service[]>>;
  isReadOnly?: boolean;
}

export default function ServiceForm({
  services,
  setServices,
  isReadOnly,
}: VolunteeringFormProps) {
  const [service, setService] = React.useState('');
  const [date, setDate] = React.useState('');
  const add = React.useCallback(
    (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      e.preventDefault();
      setServices((_services) => [
        ...(_services ?? []),
        {
          id: uuid(),
          service,
          date,
        },
      ]);
      setService('');
      setDate('');
    },
    [date, service, setServices]
  );
  const onDelete = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    if (
      typeof window !== 'undefined' &&
      window.confirm('Are you sure you want to delete this qualification?')
    ) {
      const { id } = e.currentTarget.dataset;
      setServices((_services) =>
        _services.filter((_service) => _service.id !== id)
      );
    }
  };
  return (
    <>
      <div className="grid grid-cols-1 lg:grid-cols-[2fr_1fr] gap-4 mt-4">
        {isReadOnly ? null : (
          <>
            <Textarea
              label="Service"
              rows={3}
              name="service"
              value={service}
              onChange={(e) => {
                e.preventDefault();
                setService(e.target.value);
              }}
            />
            <div className="w-full flex flex-col">
              <Input
                type="date"
                label="Date"
                name="date"
                value={date}
                onChange={(e) => {
                  e.preventDefault();
                  setDate(e.target.value);
                }}
              />
              <Button
                type="button"
                color="magenta"
                className="mb-4 mt-auto"
                onClick={add}
              >
                Add
              </Button>
            </div>
          </>
        )}
      </div>
      {services?.length > 0 ? (
        <div className="block w-full overflow-x-auto">
          <table className="items-center w-full bg-transparent border-collapse">
            <thead>
              <tr className="">
                <th className="px-2 align-middle border border-solid py-2 text-[12px] uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left text-neutral-600">
                  Date
                </th>
                <th className="px-2 align-middle border border-solid py-2 text-[12px] uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left text-neutral-600">
                  Description
                </th>
              </tr>
            </thead>
            <tbody>
              {services?.map((s) => (
                <tr key={s.id}>
                  <td className="border-t-0 px-2 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap py-1 inline-flex">
                    {isReadOnly ? null : (
                      <button
                        type="button"
                        className="w-4 h-4 mr-1 my-auto text-red-600"
                        data-id={s.id}
                        onClick={onDelete}
                      >
                        <ClearIcon className="w-4 h-4" />
                      </button>
                    )}
                    <span className="my-auto">{s.date}</span>
                  </td>
                  <td className="border-t-0 px-2 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap py-1">
                    {`${
                      s?.service?.split(' ')?.slice(0, 50)?.join(' ') ?? ''
                    }...`}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : null}
    </>
  );
}
